import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class JournalsIndexRoute extends Route {
  @service fundsService;
  @service journalService;
  @service navbarSettings;

  beforeModel() {
    this.navbarSettings.title = 'Journals';
  }

  async model() {
    await this.fundsService.confirmValidFundToken();
    await this.journalService.load();
    return {
      journalInfos: this.journalService.journals.map((journal) => {
        return this.journalService.journalInfoById(journal.id);
      }),
    };
  }
}
